import { createSlice } from '@reduxjs/toolkit';

const campaignPrizeSlice = createSlice({
  name: 'campaignPrize',
  initialState: {
    openPrizeModal: false,
    openWinnerModal: false,
    hasError: false,
  },
  reducers: {
    setOpenPrizeModal: state => ({ ...state, openPrizeModal: true }),
    unSetOpenPrizeModal: state => ({ ...state, openPrizeModal: false }),
    setOpenWinnerModal: state => ({ ...state, openWinnerModal: true }),
    unSetOpenWinnerModal: state => ({ ...state, openWinnerModal: false }),
    setHasError: state => ({ ...state, hasError: true }),
    unsetHasError: state => ({ ...state, hasError: false }),
    resetForm: state => ({ ...state, openModal: false, hasError: false }),
  },
});

export const {
  setOpenPrizeModal,
  unSetOpenPrizeModal,
  setOpenWinnerModal,
  unSetOpenWinnerModal,
  setHasError,
  unsetHasError,
  resetForm,
} = campaignPrizeSlice.actions;
export default campaignPrizeSlice.reducer;
